import React, { ReactNode } from "react";
import styled from "styled-components/macro";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { Divider, Grid, GridSize } from "@material-ui/core";

import { BoldText, Text } from "components/Text";
import { Row } from "components/Layout";

export const ReviewCard = styled.div`
  border-radius: ${({ theme }) => theme.radii[4]}px;
  box-shadow: ${({ theme }) => theme.shadows[0]};
  border: 1px solid ${({ theme }) => theme.colors.gray85};
  padding: ${({ theme }) => theme.space[2]}px;
  margin-bottom: ${({ theme }) => theme.space[2]}px;
  background: ${({ theme }) => theme.colors.white};
`;

const ReviewCardTitleRoot = styled(BoldText)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[1]}px;
  font-size: ${({ theme }) => theme.fontSizes.beta}px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: ${({ theme }) => theme.space[2]}px;
  line-height: 1.4;
`;

interface ReviewCardTitleProps {
  icon?: IconDefinition;
  children: ReactNode;
}

export const ReviewCardTitle = ({ icon, children }: ReviewCardTitleProps) => (
  <ReviewCardTitleRoot>
    {icon && <FontAwesomeIcon icon={icon} />}
    {children}
  </ReviewCardTitleRoot>
);

export const ReviewFieldGrid = styled(Grid).attrs({
  container: true,
  spacing: 2,
})`
  margin-bottom: 8px;
`;

export const ReviewFieldLabel = styled(Text)`
  display: block;
  font-size: ${({ theme }) => theme.fontSizes.alpha}px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.gray8C};
`;

interface ReviewFieldProps {
  xs?: GridSize;
  label?: ReactNode;
  children?: ReactNode;
}

export const ReviewField = ({ xs = 12, label, children }: ReviewFieldProps) => (
  <Grid item xs={xs}>
    {label != null && <ReviewFieldLabel>{label}</ReviewFieldLabel>}
    <Text fontSize="beta" color="gray40">
      {children}
    </Text>
  </Grid>
);

const SectionDividerLabel = styled.span`
  padding: 0 ${({ theme }) => theme.space[2]}px;
  font-size: 10px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: ${({ theme }) => theme.colors.gray8C};
  white-space: nowrap;
`;

export const SectionDivider = ({ children }: { children: ReactNode }) => (
  <Row fullWidth alignCenter marginVertical={2}>
    <Divider style={{ flex: 1 }} />
    <SectionDividerLabel>{children}</SectionDividerLabel>
    <Divider style={{ flex: 1 }} />
  </Row>
);
